/**
 * @author      sammy.dowds@zumper.com (Sammy Dowds)
 * @copyright   Copyright (c) 2023, Zumper
 */

export enum ListingCardSizes {
  SM = 'small',
  MD = 'medium',
  LG = 'Large',
}
